import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { motion } from "framer-motion";

import { Alert, AlertTitle, Autocomplete, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, Grid, TextField } from '@mui/material';
import TabContext from "@mui/lab/TabContext"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import Tab from "@mui/material/Tab"

import TokenContext from "../context/TokenContext";
import { empleadosOrgFETCH, posiciones, posicionesBDGT, unidadOrganizativa } from "../Redux/organigrama";
import OrganigramaArbol from "./ArbolOrganigrama";
import Header from "./Header";
import PosicionArbol from "./ArbolPosicion";
import ArbolEmpleado from "./ArbolEmpleado";
import ArbolPosicionBDGT from "./ArbolPosicionBDGT";
import { UserAuth } from "../context/AuthContext";

const Organigrama = () => {
  const dispatch = useDispatch()
  const token = useContext(TokenContext)
  const { empleado } = UserAuth()

  const [valuePrimerTab, setValuePrimerTab] = useState("4") //value del tablist

  const [unidad, setUnidad] = useState([])
  const unidadOrganizativaSelector = useSelector(store => store.organigrama.unidadOrganizativa)
  const loadingUnidadSelector = useSelector(store => store.organigrama.loadingUnidad)

  const [posicion, setPosicion] = useState([])
  const posicionesSelector = useSelector(store => store.organigrama.posiciones)
  const loadingPosicionSelector = useSelector(store => store.organigrama.loadingPosiciones)

  const empleadosSelector = useSelector(store => store.organigrama.empleados)
  const loadingEmpleadosSelector = useSelector(store => store.organigrama.loadingEmpleados)

  const [options, setOptions] = useState([])
  const [selectedUnidad, setSelectedUnidad] = useState()
  const [unidadEmpleados, setUnidadEmpleados] = useState([])

  const [posicionBDGT, setPosicionBDGT] = useState([])
  const posicionesBDGTSelector = useSelector(store => store.organigrama.posicionesBDGT)
  const loadingPosicionesBDGTSelector = useSelector(store => store.organigrama.loadingPosicionesBDGT)

  const [selectedGerencia, setSelectedGerencia] = useState(null)
  const [selectedDireccion, setSelectedDireccion] = useState(null)
  const [selectedSecretaria, setSelectedSecretaria] = useState(null)
  const [selectedNivel, setSelectedNivel] = useState([])

  const [optionsDireccion, setOptionsDireccion] = useState([])
  const [optionsGerencia, setOptionsGerencia] = useState([])
  const [optionsSecretaria, setOptionsSecretaria] = useState([])
  const [optionsNivel, setOptionsNivel] = useState([])

  const [unidadPosiciones, setUnidadPosiciones] = useState([])

  const [posicionesTotales, setPosicionesTotales] = useState([])

  const [isChecked, setIsChecked] = useState(false);

  const [isCheckedSuperior2, setIsCheckedSuperior2] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    // console.log("Checkbox checked:", event.target.checked);
  };

  const handleCheckboxChangeS2 = (event) => {
    setIsCheckedSuperior2(event.target.checked);
  };

  useEffect(() => {
    if (posicionesTotales.length > 0) {
      console.log("PosicionesTotales", posicionesTotales);
  
      if (isChecked) {
        // Agrupar las posiciones con reportaA para crear la posición superior 1
        const groupedRootNodes = {};
        posicionesTotales.forEach((node) => {
          const reportaA = node.new_reportaa;
          if (reportaA) {
            if (!groupedRootNodes[reportaA]) {
              groupedRootNodes[reportaA] = [];
            }
            groupedRootNodes[reportaA].push(node);
          } else {
            if (!groupedRootNodes["NO_SUPERIOR"]) {
              groupedRootNodes["NO_SUPERIOR"] = [];
            }
            groupedRootNodes["NO_SUPERIOR"].push(node);
          }
        });
  
        // Crear nodos superiores para cada grupo de reportaA
        const finalRootNodes = [];
        Object.keys(groupedRootNodes).forEach((reportaAKey) => {
          if (reportaAKey !== "NO_SUPERIOR") {
            const superiorNode = {
              id: groupedRootNodes[reportaAKey][0]?.new_reportaa || "Unknown Superior",
              new_idposicin: null,
              new_name: groupedRootNodes[reportaAKey][0]?.new_nameSuperior || "Unknown Superior",
              _new_empleadoactual_value: groupedRootNodes[reportaAKey][0]?.new_empleadoactualSuperior || "",
              new_reportaa: null,
              _new_reportaa_value: null,
              _new_unidadorganizativa_value: null,
              new_direccion_label: null,
              new_direccion: null,
              new_gerencia_label: null,
              new_gerencia: null,
              new_nameSuperior: null,
              new_empleadoactualSuperior: null,
              children: groupedRootNodes[reportaAKey],
            };
  
            if (isCheckedSuperior2) {
              // Lógica para agregar la posición superior 2 solo si la 1 está seleccionada
              const reportaA2 = groupedRootNodes[reportaAKey][0]?.new_reportaa2;
              if (reportaA2) {
                // Buscar si ya existe un nodo superior 2 para este grupo
                let superiorNode2 = finalRootNodes.find(node => node.id === reportaA2);
                
                if (!superiorNode2) {
                  // Si no existe, crearlo
                  superiorNode2 = {
                    id: reportaA2,
                    new_idposicin: null,
                    new_name: groupedRootNodes[reportaAKey][0]?.new_nameSuperior2 || "Unknown Superior 2",
                    _new_empleadoactual_value: groupedRootNodes[reportaAKey][0]?.new_empleadoactualSuperior2 || '',
                    new_reportaa: null,
                    _new_reportaa_value: null,
                    _new_unidadorganizativa_value: null,
                    new_direccion_label: null,
                    new_direccion: null,
                    new_gerencia_label: null,
                    new_gerencia: null,
                    new_nameSuperior: null,
                    new_empleadoactualSuperior: null,
                    children: [], // Inicialmente vacío, luego agregamos el superiorNode (superior 1)
                  };
  
                  finalRootNodes.push(superiorNode2);
                }
  
                // Agregar el nodo superior 1 (superiorNode) dentro de superiorNode2 como su hijo
                superiorNode2.children.push(superiorNode);
              } else {
                // Si no hay superior 2, simplemente agregar superior 1
                finalRootNodes.push(superiorNode);
              }
            } else {
              // Si no está activada la posición superior 2, simplemente agregar la posición superior 1
              finalRootNodes.push(superiorNode);
            }
          } else {
            // Agregar posiciones sin superior directamente al árbol
            finalRootNodes.push(...groupedRootNodes["NO_SUPERIOR"]);
          }
        });
  
        setUnidadPosiciones({
          unidadSuperiorValue: finalRootNodes[0]?.new_reportaa || "",
          unidadSuperiorLabel: finalRootNodes[0]?._new_reportaa_value || "",
          children: finalRootNodes,
        });
      } else {
        // Si no está activada la jerarquía de posiciones superiores
        setUnidadPosiciones({
          unidadSuperiorValue: posicionesTotales[0]?.new_reportaa || "",
          unidadSuperiorLabel: posicionesTotales[0]?._new_reportaa_value || "",
          children: posicionesTotales,
        });
      }
    } else {
      setUnidadPosiciones({});
    }
  }, [posicionesTotales, isChecked, isCheckedSuperior2]);
  



  useEffect(() => {
    if (token) {
      dispatch(unidadOrganizativa(token))
      dispatch(posiciones(token))
      dispatch(posicionesBDGT(token))
      if (selectedUnidad) {
        dispatch(empleadosOrgFETCH(token, selectedUnidad.value))
      }
    }
  }, [token, selectedUnidad])

  useEffect(() => {
    if (unidadOrganizativaSelector.length > 0) {
      const newArray = unidadOrganizativaSelector.map((element) => ({
        id: element.new_unidadorganigramaid,
        new_name: element.new_name,
        new_tipo: element["new_tipo@OData.Community.Display.V1.FormattedValue"],
        new_idunidadorganigrama: element.new_idunidadorganigrama,
        _new_direccion_value:
          element["_new_direccion_value@OData.Community.Display.V1.FormattedValue"],
        _new_empresa_value:
          element["_new_empresa_value@OData.Community.Display.V1.FormattedValue"],
        new_unidadsuperior:
          element["_new_unidadsuperior_value@OData.Community.Display.V1.FormattedValue"],
        _new_unidadsuperior_value: element._new_unidadsuperior_value,
      }));

      // Ordenar el nuevo array por la propiedad new_name
      const sortedArray = newArray.slice().sort((a, b) =>
        a.new_name.localeCompare(b.new_name)
      );

      // Crear un conjunto para eliminar duplicados
      const uniqueLabels = new Set();

      // Crear array con objetos { value, label } y eliminar duplicados
      const valueLabelArray = sortedArray.reduce((acc, element) => {
        const label = element.new_unidadsuperior;

        if (label !== undefined && !uniqueLabels.has(label)) {
          uniqueLabels.add(label);
          acc.push({
            value: element._new_unidadsuperior_value, // o element.new_unidadorganigramaid, según lo que necesites
            label: label,
          });
        }

        return acc;
      }, []);

      // Ordenar valueLabelArray alfabéticamente por la propiedad label
      const sortedValueLabelArray = valueLabelArray.slice().sort((a, b) =>
        a.label.localeCompare(b.label)
      );

      setUnidad(sortedArray);
      setOptions(sortedValueLabelArray);
    }
  }, [unidadOrganizativaSelector]);

  useEffect(() => {
    if (posicionesSelector.length > 0) {
      const newArray = posicionesSelector.map((element) => ({
        id: element.new_posicionid,
        new_idposicin: element.new_idposicin,
        new_name: element.new_name,
        statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
        _new_empleadoactual_value: element["_new_empleadoactual_value@OData.Community.Display.V1.FormattedValue"],
        _new_empresa_value: element["_new_empresa_value@OData.Community.Display.V1.FormattedValue"],
        _new_puesto_value: element["_new_puesto_value@OData.Community.Display.V1.FormattedValue"],
        _new_reportaa_value: element["_new_reportaa_value@OData.Community.Display.V1.FormattedValue"],
        _new_unidadorganizativa_value: element["_new_unidadorganizativa_value@OData.Community.Display.V1.FormattedValue"]
      }));
      // Ordenar el nuevo array por la propiedad new_name
      const sortedArray = newArray.slice().sort((a, b) =>
        a.new_name.localeCompare(b.new_name)
      );

      setPosicion(sortedArray);
    }
  }, [posicionesSelector]);

  useEffect(() => {
    if ( posicionesBDGTSelector.length > 0) {
      console.log("posicionesBDGTSelector",posicionesBDGTSelector)
      const newArray = posicionesBDGTSelector.map((element) => ({
        id: element.new_posicionid,
        new_idposicin: element.new_idposicin,
        new_name: element.new_name,
        statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
        _new_empleadoactual_value: element["_new_empleadoactual_value@OData.Community.Display.V1.FormattedValue"],
        new_numerolegajo: element["ac.new_numerolegajo"],

        _new_empresa_value: element["_new_empresa_value@OData.Community.Display.V1.FormattedValue"],
        _new_puesto_value: element["_new_puesto_value@OData.Community.Display.V1.FormattedValue"],

        _new_reportaa_value: element["_new_reportaa_value@OData.Community.Display.V1.FormattedValue"],
        _new_unidadorganizativa_value: element["_new_unidadorganizativa_value@OData.Community.Display.V1.FormattedValue"],

        new_direccion_label: element["ab.new_direccion@OData.Community.Display.V1.FormattedValue"],
        new_direccion: element["ab.new_direccion"],

        new_gerencia_label: element["ab.new_gerencia@OData.Community.Display.V1.FormattedValue"],
        new_gerencia: element["ab.new_gerencia"],

        new_secretaria_label: element["ab.new_secretaria@OData.Community.Display.V1.FormattedValue"],
        new_secretaria: element["ab.new_secretaria"],

        new_nivel_label: element["_new_nivel_value@OData.Community.Display.V1.FormattedValue"],
        new_nivel: element["_new_nivel_value"],

        // Posición superior
        new_reportaa: element._new_reportaa_value,
        new_nameSuperior: element["ad.new_name"],
        new_empleadoactualSuperior: element["ad.new_empleadoactual@OData.Community.Display.V1.FormattedValue"],

        // Posición superior 2
        new_reportaa2: element["ad.new_reportaa"],
        new_nameSuperior2: element["ae.new_name"],
        new_empleadoactualSuperior2: element["ae.new_empleadoactual@OData.Community.Display.V1.FormattedValue"],

      }));

      // Ordena el array por new_name
      const sortedArray = newArray.slice().sort((a, b) =>
        a.new_name.localeCompare(b.new_name)
      );

      // const uniqueLabels = new Set(); Elimina duplicados
      const uniqueDireccionLabels = new Set();
      const uniqueGerenciaLabels = new Set();
      const uniqueSecretariaLabels = new Set();
      const uniqueNivelLabels = new Set();

      const valueLabelArrayDireccion = sortedArray.reduce((acc, element) => {
        const label = element.new_direccion_label;

        if (label !== undefined && !uniqueDireccionLabels.has(label)) {
          uniqueDireccionLabels.add(label);
          acc.push({
            value: element.new_direccion,
            label: label,
          });
        }

        return acc;
      }, []);

      const valueLabelArrayGerencia = sortedArray.reduce((acc, element) => {
        const label = element.new_gerencia_label;

        if (label !== undefined && !uniqueGerenciaLabels.has(label)) {
          uniqueGerenciaLabels.add(label);
          acc.push({
            value: element.new_gerencia,
            label: label,
          });
        }

        return acc;
      }, []);

      const valueLabelArraySecretaria = sortedArray.reduce((acc, element) => {
        const label = element.new_secretaria_label;

        if (label !== undefined && !uniqueSecretariaLabels.has(label)) {
          uniqueSecretariaLabels.add(label);
          acc.push({
            value: element.new_secretaria,
            label: label,
          });
        }

        return acc;
      }, []);

      const valueLabelArrayNivel = sortedArray.reduce((acc, element) => {
        const label = element.new_nivel_label;

        if (label !== undefined && !uniqueNivelLabels.has(label)) {
          uniqueNivelLabels.add(label);
          acc.push({
            value: element.new_nivel,
            label: label,
          });
        }

        return acc;
      }, []);


      // Ordena valueLabelArray alfabéticamente por la propiedad label
      const sortedValueLabelArrayDireccion = valueLabelArrayDireccion.slice().sort((a, b) =>
        a.label.localeCompare(b.label)
      );

      const sortedValueLabelArrayGerencia = valueLabelArrayGerencia.slice().sort((a, b) =>
        a.label.localeCompare(b.label)
      );

      const sortedValueLabelArraySecretaria = valueLabelArraySecretaria.slice().sort((a, b) =>
        a.label.localeCompare(b.label)
      );

      const sortedValueLabelArrayNivel = valueLabelArrayNivel.slice().sort((a, b) =>
        a.label.localeCompare(b.label)
      );

      if (selectedDireccion || selectedGerencia || selectedSecretaria) {

        // Filtro por nivel
        const filteredArray = selectedNivel.length > 0
        ? sortedArray.filter(element => selectedNivel.includes(element.new_nivel))
        : sortedArray;

        setPosicionBDGT(filteredArray);

      } else {
        setPosicionBDGT([]);
      }
      setOptionsDireccion(sortedValueLabelArrayDireccion)
      setOptionsGerencia(sortedValueLabelArrayGerencia)
      setOptionsSecretaria(sortedValueLabelArraySecretaria)
      setOptionsNivel(sortedValueLabelArrayNivel)
    }
  }, [posicionesBDGTSelector]);

  useEffect(() => {
    dispatch(posicionesBDGT(token, selectedGerencia?.value, selectedSecretaria?.value, selectedDireccion?.value, selectedNivel));
  }, [selectedGerencia, selectedSecretaria, selectedDireccion, selectedNivel, token]);

  const handleChangeFilter = (tipo) => (event, value) => {
    
    if (tipo == "gerencia") setSelectedGerencia(value)
    if (tipo == "direccion") setSelectedDireccion(value)
    if (tipo == "secretaria") setSelectedSecretaria(value)
    if (tipo == "nivel") setSelectedNivel(value.map((v) => v.value));
};


  useEffect(() => {
    if (empleadosSelector.length > 0 && selectedUnidad) {

      const transformedData = {
        unidadSuperiorValue: selectedUnidad.value,
        unidadSuperiorLabel: selectedUnidad.label,
        children: transformData(empleadosSelector),
      };
      setUnidadEmpleados(transformedData);
    }
  }, [empleadosSelector, selectedUnidad]);

  useEffect(() => {
    if ( posicionBDGT.length > 0) {
      const posicionesIndex = {};
      posicionBDGT.forEach((posicion) => {
        posicionesIndex[posicion.id] = {
          ...posicion,
          children: [] // Inicializa el array de nodos hijos
        };
      });
  
      // Construye la jerarquia
      const rootNodes = [];
      posicionBDGT.forEach((posicion) => {
        const reportaA = posicion.new_reportaa;
  
        if (reportaA && posicionesIndex[reportaA]) {
          posicionesIndex[reportaA].children.push(posicionesIndex[posicion.id]);
        } else {
          // si no se cumple, es un nodo raíz
          rootNodes.push(posicionesIndex[posicion.id]);
        }
      });
  
      const cleanEmptyChildren = (nodes) => {
        nodes.forEach(node => {
            if (node.children && node.children.length > 0) {
                cleanEmptyChildren(node.children); // Llamada recursiva
            } else if (node.children.length === 0) {
                delete node.children; // Eliminar el campo 'children' si está vacío
            }
        });
      };

      // Limpiar los 'children' vacíos en rootNodes
      cleanEmptyChildren(rootNodes);


      
      // if (rootNodes.length > 0) {
      //   const firstRootNode = rootNodes[0];
        
      //   // Crear una copia profunda de rootNodes para evitar referencias circulares
      //   const rootNodesCopy = JSON.parse(JSON.stringify(rootNodes));
  
      //   // Crear un nuevo nodo superior
      //   const newSuperiorNode = {
      //     id: firstRootNode.new_reportaa || '', // ID único para el nuevo nodo
      //     new_idposicin: null, // No hay ID de posición específico
      //     new_name: firstRootNode.new_nameSuperior || 'Unknown Superior', // Nombre del superior
      //     statuscode: '', // No reporta a nadie
      //     _new_empleadoactual_value: firstRootNode.new_empleadoactualSuperior || 'Unknown Employee', // Empleado actual superior
      //     new_numerolegajo: null, // No reporta a nadie
      //     _new_empresa_value: '', // No reporta a nadie
      //     new_reportaa: null, // No reporta a nadie
      //     _new_reportaa_value: null, // No hay valor de reporta
      //     _new_unidadorganizativa_value: null, // Sin unidad organizativa
      //     new_direccion_label: null, // Sin dirección
      //     new_direccion: null, // Sin dirección
      //     new_nameSuperior: null, // No hay más superiores por encima
      //     new_empleadoactualSuperior: null, // No hay empleado superior por encima
      //     new_gerencia_label: null, // Sin gerencia
      //     new_gerencia: null, // Sin gerencia
      //     children: rootNodesCopy // Agregar la copia de rootNodes como hijos
      //   };

      //   // Ahora el nuevo nodo superior se convierte en el único nodo raíz
      //   rootNodes.length = 0; // Limpiar el array rootNodes
      //   rootNodes.push(newSuperiorNode);
      // }
  
      // console.log("posicionesBDGTSelector UnidadPosiciones", {
      //   unidadSuperiorValue: rootNodes[0]?.new_reportaa || '',
      //   unidadSuperiorLabel: rootNodes[0]?._new_reportaa_value || '',
      //   children: rootNodes, // Contiene la jerarquía completa con el nuevo nodo superior
      // });

// ************************************************************************************************************

      // Agrupar nodos raíz por 'reportaA'
    // const groupedRootNodes = {};
    // rootNodes.forEach(node => {
    //   const reportaA = node.new_reportaa;
    //   if (reportaA) {
    //     // Si el nodo raíz tiene un `reportaA`, agruparlo bajo ese `reportaA`
    //     if (!groupedRootNodes[reportaA]) {
    //       groupedRootNodes[reportaA] = [];
    //     }
    //     groupedRootNodes[reportaA].push(node);
    //   } else {
    //     // Si no hay `reportaA`, asignarlo a un grupo especial
    //     if (!groupedRootNodes['NO_SUPERIOR']) {
    //       groupedRootNodes['NO_SUPERIOR'] = [];
    //     }
    //     groupedRootNodes['NO_SUPERIOR'].push(node);
    //   }
    // });

    // // Crear nodos superiores para cada grupo de `reportaA`
    // const finalRootNodes = [];
    // Object.keys(groupedRootNodes).forEach(reportaAKey => {
    //   if (reportaAKey !== 'NO_SUPERIOR') {
    //     // Crear un nodo superior para el grupo con `reportaA`
    //     const superiorNode = {
    //       id: groupedRootNodes[reportaAKey][0]?.new_reportaa || 'Unknown Superior',
    //       new_idposicin: null,
    //       new_name: groupedRootNodes[reportaAKey][0]?._new_reportaa_value || 'Unknown Superior',
    //       new_empleadoactual: groupedRootNodes[reportaAKey][0]?._new_empleadoactual_value || '', // Si se requiere agregar algún valor predeterminado 
    //       new_reportaa: null, // Superior del superior si es necesario
    //       _new_reportaa_value: null, // Valor del superior del superior si es necesario
    //       _new_unidadorganizativa_value: null,
    //       new_direccion_label: null,
    //       new_direccion: null,
    //       new_gerencia_label: null,
    //       new_gerencia: null,
    //       new_nameSuperior: null,
    //       new_empleadoactualSuperior: null,
    //       children: groupedRootNodes[reportaAKey] // Agregar nodos raíz del grupo como hijos
    //     };
    //     finalRootNodes.push(superiorNode);
    //   } else {
    //     // Agregar nodos sin superior directamente
    //     finalRootNodes.push(...groupedRootNodes['NO_SUPERIOR']);
    //   }
    // });

    // // Log para ver la estructura generada
    // console.log("posicionesBDGTSelector UnidadPosiciones", {
    //   unidadSuperiorValue: finalRootNodes[0]?.new_reportaa || '',
    //   unidadSuperiorLabel: finalRootNodes[0]?._new_reportaa_value || '',
    //   children: finalRootNodes, // Contiene la jerarquía completa con los nuevos nodos superiores
    // });


    //   // setUnidadPosiciones({
    //   //   unidadSuperiorValue: rootNodes[0]?.new_reportaa || '',
    //   //   unidadSuperiorLabel: rootNodes[0]?._new_reportaa_value || '',
    //   //   children: rootNodes, // Contiene la jerarquía completa
    //   // });
    //   setUnidadPosiciones({
    //     unidadSuperiorValue: finalRootNodes[0]?.new_reportaa || '',
    //     unidadSuperiorLabel: finalRootNodes[0]?._new_reportaa_value || '',
    //     children: finalRootNodes, // Contiene la jerarquía completa con los nuevos nodos superiores
    //   });

      setPosicionesTotales(rootNodes)
    } else {
      // setUnidadPosiciones({});
      setPosicionesTotales([])
    }
  }, [posicionBDGT]);
  
  

  const handleChangePrimerTAB = (event, newValue) => {
    setValuePrimerTab(newValue)
  }

  //onchange de arbol de empleados
  const handleChangeUnidad = (event, value) => {
    setSelectedUnidad(value ? value : null);
  };

  // Función para transformar el array
  const transformArray = (originalArray) => {
    const newArray = [];

    originalArray.forEach(obj => {
      if (obj._new_reportaa_value) {
        const unidadSuperiorValue = obj._new_reportaa_value;
        const unidadSuperiorLabel = obj["_new_reportaa_value@OData.Community.Display.V1.FormattedValue"];

        // Filtrar el array original por _new_reportaa_value
        const hijos = originalArray.filter(hijo => hijo._new_reportaa_value === unidadSuperiorValue);

        // Crear el nuevo objeto con las propiedades requeridas
        const nuevoObjeto = {
          unidadSuperiorValue,
          unidadSuperiorLabel,
          children: hijos, // Agregar todos los objetos relacionados
        };

        // Agregar el nuevo objeto al array resultante solo si no está ya presente
        if (!newArray.find(item => item.unidadSuperiorValue === unidadSuperiorValue)) {
          newArray.push(nuevoObjeto);
        }
      }
    });

    return newArray;
  };
  
  // Llamar a la función para obtener el nuevo array
  const nuevoArray = transformArray(posicionesSelector);

  const transformData = (data) => {
    const employeeMap = {};
    const result = [];
  
    // Primero, construimos un mapa para un acceso más eficiente por _new_reportaaid_value
    data.forEach(employee => {
      const newEmployee = {
        ...employee,
        children: []
      };
      employeeMap[employee.new_empleadoid] = newEmployee;
    });
  
    // Ahora, construimos la jerarquía
    data.forEach(employee => {
      const { _new_reportaaid_value } = employee;
      const parentEmployee = employeeMap[_new_reportaaid_value];
  
      if (parentEmployee) {
        parentEmployee.children.push(employeeMap[employee.new_empleadoid]);
      } else {
        // Si no tiene _new_reportaaid_value, lo agregamos al resultado principal
        result.push(employeeMap[employee.new_empleadoid]);
      }
    });
  
    return result;
  };

  const clearFilters = () => {

    setSelectedSecretaria(null);
    setSelectedDireccion(null);
    setSelectedGerencia(null);
    setSelectedNivel([]);
    
    setOptionsDireccion([]);
    setOptionsGerencia([]);
    setOptionsSecretaria([]);
    setOptionsNivel([]);
    
    setIsChecked(false)
    setIsCheckedSuperior2(false)
    // Verificar el estado después de limpiarlo
    // console.log("Filtros limpiados", {
    //   selectedSecretaria,
    //   selectedDireccion,
    //   selectedGerencia,
    //   selectedNivel,
    //   optionsDireccion,
    //   optionsGerencia,
    //   optionsSecretaria,
    //   optionsNivel
    // });
  };
  

  useEffect(() => {
    // console.log("Filtros cambiados", {
    //   selectedSecretaria,
    //   selectedDireccion,
    //   selectedGerencia,
    //   selectedNivel,
    //   optionsDireccion,
    //   optionsGerencia,
    //   optionsSecretaria,
    //   optionsNivel
    // });
  }, [optionsDireccion, optionsGerencia, optionsSecretaria, optionsNivel]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <Box
        m="1.5rem 2.5rem"
      >
        <Header title={"Organigrama"} subtitle={empleado && empleado.habilitadoOrganigrama ? "En esta sección podrás visualizar y filtrar el organigrama." : "No estas autorizado para visualizar este contenido"} />
        {empleado && empleado.habilitadoOrganigrama ? (
        <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
            <TabContext value={valuePrimerTab}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <TabList
                  aria-label="scrollable force tabs example"
                  onChange={handleChangePrimerTAB}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  textColor="secondary"
                  indicatorColor="secondary"
                >
                  <Tab label="Unidad Organizativa" value="1" sx={{ fontWeight: 'bold', fontSize: '16px', display: 'none' }} />
                  <Tab label="Posiciones" value="2" sx={{ fontWeight: 'bold', fontSize: '16px', display: 'none' }} />
                  <Tab label="Empleados" value="3" sx={{ fontWeight: 'bold', fontSize: '16px', display: 'none' }} />
                  <Tab label="Organigrama por posiciones" value="4" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                </TabList>
              </Box>

              <TabPanel value="1">
                {
                  loadingUnidadSelector ? (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                        py: 2
                      }}>
                      <CircularProgress color="secondary" />
                    </Box>
                  ) : unidad.length > 0 ? (
                    <OrganigramaArbol organigrama={unidad} />) :
                    <Alert severity="error">
                      <AlertTitle>Info</AlertTitle>
                      El <strong>Organigrama</strong> no pudo ser cargado.
                    </Alert>
                }
              </TabPanel>
              <TabPanel value="2">
                {
                  loadingPosicionSelector ? (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                        py: 2
                      }}>
                      <CircularProgress color="secondary" />
                    </Box>
                  ) : posicion.length > 0 ? (
                    <PosicionArbol organigrama={nuevoArray} />) :
                    <Alert severity="error">
                      <AlertTitle>Info</AlertTitle>
                      El <strong>Organigrama</strong> no pudo ser cargado.
                    </Alert>
                }
              </TabPanel>
              <TabPanel value="3">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControl fullWidth sx={{ marginBottom: 2, padding: 4 }}>
                      <Autocomplete
                        value={options.find(
                          (option) => option.value === selectedUnidad
                        )}
                        onChange={handleChangeUnidad}
                        options={options}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Seleccione una unidad organizativa"
                          />
                        )}
                      />
                    </FormControl>
                    {
                      loadingEmpleadosSelector ? (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            height: '100%',
                            py: 2
                          }}>
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : Object.keys(unidadEmpleados).length > 0 ? (
                        <ArbolEmpleado organigrama={unidadEmpleados} unidad={selectedUnidad} />) :
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          No hay un <strong>Organigrama</strong> cargado.
                        </Alert>
                    }
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value="4">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControl fullWidth sx={{ marginBottom: 2, padding: 4 }}>
                      <Box mt={2}>
                        <Autocomplete
                          // value={(optionsSecretaria.find(
                          //   (option) => option.value === selectedSecretaria
                          // ))|| null}
                          value={selectedSecretaria}
                          onChange={handleChangeFilter("secretaria")}
                          options={optionsSecretaria}
                          getOptionLabel={(option) => option.label}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Seleccione una secretaria"
                            />
                          )}
                          disabled={ loadingPosicionesBDGTSelector || selectedNivel.length > 0 }
                        />
                      </Box>
                      <Box mt={2}>
                        <Autocomplete
                          // value={optionsDireccion.find(
                          //   (option) => option.value === selectedDireccion
                          // )}
                          value={selectedDireccion}
                          onChange={handleChangeFilter("direccion")}
                          options={optionsDireccion}
                          getOptionLabel={(option) => option.label}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Seleccione una dirección"
                            />
                          )}
                          disabled={ loadingPosicionesBDGTSelector || selectedNivel.length > 0 }
                        />
                      </Box>
                      <Box mt={2}>
                        <Autocomplete
                          // value={optionsGerencia.find(
                          //   (option) => option.value === selectedGerencia
                          // )}
                          value={selectedGerencia}
                          onChange={handleChangeFilter("gerencia")}
                          options={optionsGerencia}
                          getOptionLabel={(option) => option.label}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Seleccione una gerencia"
                            />
                          )}
                          disabled={ loadingPosicionesBDGTSelector || selectedNivel.length > 0 }
                        />
                      </Box>
                      <Box mt={2}>
                        <Autocomplete
                          multiple
                          // value={optionsNivel.filter(
                          //   (option) => selectedNivel?.includes(option.value)
                          // )}
                          value={ optionsNivel.filter(
                            option => selectedNivel?.includes(option.value))
                          }
                          onChange={handleChangeFilter("nivel")}
                          options={optionsNivel}
                          getOptionLabel={(option) => option.label}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Seleccione uno o más niveles"
                            />
                          )}
                          disabled={ loadingPosicionesBDGTSelector ||
                            !(
                              (selectedSecretaria && !selectedDireccion && !selectedGerencia) ||
                              (!selectedSecretaria && selectedDireccion && !selectedGerencia) ||
                              (!selectedSecretaria && !selectedDireccion && selectedGerencia)
                            )
                          }
                        />
                      </Box>

                      <Box mt={2} display="flex" alignItems="center" justifyContent="space-between">
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                disabled={isCheckedSuperior2}
                              />
                            }
                            label="Ver posición superior"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={isCheckedSuperior2}
                                onChange={handleCheckboxChangeS2}
                                disabled={!isChecked}
                              />
                            }
                            label="Ver posición superior 2"
                          />
                        </Box>

                        <Button
                          variant="outlined"
                          color="error"
                          onClick={clearFilters}
                          disabled={
                            loadingPosicionesBDGTSelector ||
                            (!selectedSecretaria &&
                              !selectedDireccion &&
                              !selectedGerencia &&
                              selectedNivel.length === 0 &&
                              !isChecked)
                          }
                        >
                          Limpiar Filtros
                        </Button>
                      </Box>


                    </FormControl>
                    {
                      loadingPosicionesBDGTSelector ? (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            height: '100%',
                            py: 2
                          }}>
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : (selectedDireccion || selectedGerencia || selectedSecretaria) && Object.keys(unidadPosiciones).length > 0 ? (
                        <Box>
                          <ArbolPosicionBDGT organigrama={unidadPosiciones} direccion={selectedDireccion}
                            gerencia={selectedGerencia} secretaria= {selectedSecretaria} nivel={optionsNivel.filter(option => selectedNivel.includes(option.value))} />
                        </Box>
                      ) :
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          No hay un <strong>Organigrama</strong> cargado.
                        </Alert>
                    }
                  </Grid>
                </Grid>
              </TabPanel>
            </TabContext>
          </Grid>
        </Grid>
        </>
        ) : null}
      </Box>
    </motion.div>
  )
}

export default Organigrama